<template>
  <g
    :class="{ 'interactive__spot--hovered': hoveredShapeIndex === item.originalIndex && item.shape.type === 'spot', 'interactive__polygon--hovered': hoveredShapeIndex === item.originalIndex && item.shape.type === 'poly' }"
    @mouseenter="$emit('area-mouseenter', $event, item.shape, item.originalIndex)"
    @mousemove="$emit('area-mousemove', $event, item.shape, item.originalIndex)"
    @mouseleave="$emit('area-mouseleave')"
    @click="$emit('area-click', item.shape)">
    <template v-if="item.shape.type === 'spot'">
      <!-- The Circle -->
      <circle
        role="button"
        class="interactive__link"
        :cx="`${(Math.round(item.shape.coords.split(',')[0]*10000)/100)}%`"
        :cy="`${(Math.round(item.shape.coords.split(',')[1]*10000)/100)}%`"
        :r="circleRadius"
        vector-effect="non-scaling-size"
        fill="rgba(51, 51, 51, 0.8)"
        stroke="rgba(255, 255, 255, 0.50)"
        stroke-width="2"></circle>

      <!-- The Number inside -->
      <text
        v-if="item.shape.displayNumber"
        class="interactive__spot-text"
        :x="`${(Math.round(item.shape.coords.split(',')[0]*10000)/100)}%`"
        :y="`${(Math.round(item.shape.coords.split(',')[1]*10000)/100)}%`"
        font-family="Arial"
        :font-size="circleRadius * 0.65"
        font-weight="bold"
        fill="white"
        text-anchor="middle"
        dominant-baseline="central">
        {{ item.shape.displayNumber }}
      </text>
      <circle
        v-else
        role="button"
        class="interactive__link"
        :cx="`${(Math.round(item.shape.coords.split(',')[0]*10000)/100)}%`"
        :cy="`${(Math.round(item.shape.coords.split(',')[1]*10000)/100)}%`"
        :r="circleRadius / 3"
        vector-effect="non-scaling-size"
        fill="white"
        stroke="rgba(255, 255, 255, 0.50)"
        stroke-width="2"></circle>
    </template>
    <template v-else-if="item.shape.type === 'poly' && imageNaturalWidth && imageNaturalHeight">
      <polygon
        role="button"
        class="interactive__link"
        :points="item.shape.coords.split(',').filter(coord => coord !== 'NaN').map((coord, index) => index % 2 === 0 ? Math.round(coord * imageNaturalWidth) : Math.round(coord * imageNaturalHeight)).join(',')"
        fill="transparent"
        style="filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.25));"
        stroke="rgba(255, 255, 255, 0.50)"
        stroke-width="2"></polygon>
      <text
        v-if="item.shape.displayNumber"
        class="interactive__spot-text"
        :x="polyCenter(item.shape.coords).x * imageNaturalWidth"
        :y="polyCenter(item.shape.coords).y * imageNaturalHeight"
        font-family="Arial"
        :font-size="circleRadius * 0.65"
        font-weight="bold"
        fill="white"
        text-anchor="middle"
        dominant-baseline="central">
        {{ item.shape.displayNumber }}
      </text>
    </template>
  </g>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true
    },
    circleRadius: {
      type: Number,
      default: 20
    },
    imageNaturalWidth: {
      type: Number,
      default: 0
    },
    imageNaturalHeight: {
      type: Number,
      default: 0
    },
    hoveredShapeIndex: {
      type: Number,
      default: null
    }
  },
  setup () {
    const polyCenter = (coords) => {
      const values = coords.split(',').filter(c => c !== 'NaN').map(Number).filter(n => !isNaN(n))
      let sumX = 0; let sumY = 0; let count = 0
      for (let i = 0; i + 1 < values.length; i += 2) {
        sumX += values[i]
        sumY += values[i + 1]
        count++
      }
      return count > 0 ? { x: sumX / count, y: sumY / count } : { x: 0.5, y: 0.5 }
    }

    return { polyCenter }
  }
})
</script>

<style lang="scss">
.interactive__link {
  cursor: pointer;
  transition: stroke 0.2s ease, stroke-width 0.2s ease;
}

.interactive__spot-text {
  pointer-events: none;
  user-select: none;
}

.interactive__spot--hovered {
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.4));
  .interactive__link {
    stroke: rgba(255, 255, 255, 0.9);
    stroke-width: 3;
  }
}
.interactive__polygon--hovered {
  .interactive__link {
    stroke: rgba(255, 255, 255, 0.9);
    stroke-width: 3;
    fill: rgba(51, 51, 51, 0.3) !important;
  }
}
</style>
